import React, { useEffect, useRef } from 'react';

export const Cursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);
  const mouse = useRef({ x: 0, y: 0 });
  const pos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const move = (e) => { mouse.current = { x: e.clientX, y: e.clientY }; };
    const animate = () => {
      pos.current.x += (mouse.current.x - pos.current.x) * 0.15;
      pos.current.y += (mouse.current.y - pos.current.y) * 0.15;
      if (ring.current) ring.current.style.transform = `translate(${pos.current.x - 20}px, ${pos.current.y - 20}px)`;
      if (dot.current) dot.current.style.transform = `translate(${mouse.current.x - 4}px, ${mouse.current.y - 4}px)`;
      requestAnimationFrame(animate);
    };
    window.addEventListener('mousemove', move);
    requestAnimationFrame(animate);
    return () => window.removeEventListener('mousemove', move);
  }, []);

  useEffect(() => {
    const checkHover = (e) => {
      const t = e.target;
      if (ring.current) t.closest('a, button, .gallery-item, .hero-scroll, .modal-close, .lightbox-nav') ? ring.current.classList.add('hover') : ring.current.classList.remove('hover');
    };
    window.addEventListener('mouseover', checkHover);
    return () => window.removeEventListener('mouseover', checkHover);
  }, []);

  return (<><div className="cursor-dot" ref={dot} /><div className="cursor-ring" ref={ring} /></>);
};